import { COLORS } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import { Field } from 'formik';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1440rem;
  margin: 0 auto;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.WHITE};
  border-radius: 10rem;
  padding: 40rem;
  width: 100%;
  gap: 10rem;

  ${respondTo.bigPhone`
    padding: 20rem;
  `}
`;

export const SectionTitle = styled.span`
  font-size: 30rem;
  font-weight: 400;
  color: ${COLORS.BLACK};
  margin-bottom: 10rem;
`;

export const GroupLabel = styled.span`
  font-size: 15rem;
  font-weight: 400;
  text-transform: uppercase;
  color: ${COLORS.BLACK};
  margin-top: 20rem;
`;

export const Row = styled.div`
  display: flex;
  gap: 30rem;
  width: 100%;
  max-width: 100%;

  ${respondTo.horizontalTablet`
    flex-wrap: wrap;
  `}

  ${respondTo.smallTablet`
    flex-direction: column;
    gap: 20rem;
  `}
`;

export const SelectWrapper = styled.div`
  width: 100%;
  max-width: 100%;

  ${respondTo.horizontalTablet`
    width: 30%;
  `}

  ${respondTo.smallTablet`
    width: 100%;
  `}
`;

export const StyledSelect = styled(Field)`
  width: 100%;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1rem;
  background-color: ${COLORS.BORDER};
  margin: 30rem 0;
`;

export const AlternativeAddressRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20rem;
`;
